module.exports = __webpack_public_path__ + "img/file-medical.61a4496b.svg";